import React from 'react';
import {Form, Input, InputNumber, Modal, Switch} from 'antd';
import connect from "react-redux/es/connect/connect";
import {injectIntl} from "react-intl-context";
import Row from "antd/es/grid/row";
const {confirm} = Modal;
const FormItem = Form.Item;
const {TextArea} = Input;
const formItemLayout = {
    labelCol: {span: 10},
    wrapperCol: {span: 30},
};

const defaultProps = {
    value: {},
    visible: false,
    onClose: () => {
    },
};

class ImportMajiaModel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    onSubmit = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                const {onSuccess} = this.props;
                confirm({
                    content: '确认要注入马甲吗?',
                    okText: '确认',
                    okType: 'danger',
                    cancelText: '取消',
                    onOk() {
                        onSuccess && onSuccess(values)
                    },
                    onCancel() {
                    },

                });
            }
        });
    }

    onChange =(checked) => {
        console.log(`switch to ${checked}`);
    }
    render() {
        const {getFieldDecorator} = this.props.form;
        let {visible} = this.props;

        return (
            <Modal
                visible={visible}
                title="批量注入"
                onCancel={this.props.onClose}
                cancelText="取消"
                onOk={this.onSubmit}
                okText="确认"
            >
                <Form >
                    <FormItem
                        label="注入马甲数量"
                        {...formItemLayout}
                    >
                        {getFieldDecorator('vestNum', {
                            rules: [{required: true, message: '请输入注入马甲数量!'}]
                        })(
                            <InputNumber min={1} />
                        )}<span className="ant-form-text">个</span>
                    </FormItem>
                    <FormItem
                        label="马甲号关注数区间开始值"
                        {...formItemLayout}
                    >
                        {getFieldDecorator('areaStart', {
                            rules: [{required: true, message: '请输入马甲号关注数区间开始值!'}]
                        })(
                            <InputNumber min={1} />
                        )}
                    </FormItem>
                    <FormItem
                        label="马甲号关注数区间结束值"
                        {...formItemLayout}
                    >
                        {getFieldDecorator('areaEnd', {
                            rules: [{required: true, message: '请输入马甲号关注数区间结束值!'}]
                        })(
                            <InputNumber min={1} />
                        )}
                    </FormItem>
                </Form>
            </Modal>

        );
    }
}

const mapStateToProps = (state) => {
    return {
        ...state.Team,
    }
};
const mapDispatchToProps = ({
});
ImportMajiaModel.defaultProps = defaultProps;
export default connect(
    mapStateToProps, mapDispatchToProps,
)(injectIntl(Form.create()(ImportMajiaModel)));
